// import { useEffect } from 'react';
import { map } from 'lodash';
import DOMPurify from 'dompurify';

import dataFromDefaultJson from '../data.json';
// import { elementInViewport } from "../../../utils/helper";

const AndroidVideoSequence = ({ data, idPrefix }) => {

  // TODO : Comment below once related class to position video as fixed with fade-in/fade-out effect is added in the template
  /* useEffect(() => {
    const videoParentDiv = document.querySelector(
      `#edint-video-scroll-play-app-container-${idPrefix}`
    );
    const videoDiv = videoParentDiv?.children[0];

    console.log(videoDiv)

    elementInViewport(
      videoParentDiv,
      () => {
        if (videoDiv && videoDiv.firstChild) {
          videoDiv.classList.add("show-video-full-width");
        }
      },
      {
        single: false,
      },
      () => {
        if (videoDiv && videoDiv.classList) {
          videoDiv.classList.remove("show-video-full-width");
        }
      }
    );
  }); */

  const textContainerHeight = "800vh";

  const { backgroundVideo, texts, posterImage } = data;

  return (
    <div className='edint-video-scroll-play-app-container' id={`edint-video-scroll-play-app-container-${idPrefix}`} data-videoclass={idPrefix} style={{ height: textContainerHeight }}>
      <div className="media video" data-videoclass={idPrefix}>
        <video className={`edint-video-scroll-play-video-android`} data-videoclass={idPrefix} id={`edint-video-scroll-play-video-android-${idPrefix}`} src={backgroundVideo.mobileSrc} type="html5video" tabIndex="0" muted="muted" preload="auto" poster={posterImage.mobileSrc} playsInline webkit-playsinline="true" loop="loop" autoPlay>
          <source type="video/mp4" />
          {backgroundVideo.text}
        </video>
      </div>
      <div className="edint-video-scroll-play-texts-android" id={`edint-video-scroll-play-texts-android-${idPrefix}`} data-videoclass={idPrefix}>
        {map(texts, (textContent, index) => {
          return (
            <div id={`edint-video-scroll-play-textbox-android-${index}`} data-videoclass={idPrefix} key={index}>
              <p dangerouslySetInnerHTML = { {__html: DOMPurify.sanitize(textContent?.text) } }/>
            </div>
          )
        })}
      </div>
    </div>
  );
}

AndroidVideoSequence.defaultProps = {
  data: dataFromDefaultJson,
  idPrefix: 'temp'
}

export default AndroidVideoSequence;